<template>
  <div class="neighborViewEdit">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_returnNeighborView')}}</el-button>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="wid100" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_community')" prop="gardenId">
          <el-select 
            v-if="this.id"
            class="single-select"
            v-model="ruleForm.gardenId" 
            :placeholder="$t('lang.lab_selectCommunity')"
            >
            <el-option v-for="(item, index)  in garden" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select 
            v-else
            class="multiple-select"
            v-model="ruleForm.gardenIds" 
            :placeholder="$t('lang.lab_selectCommunity')"
            multiple
            filterable
            clearable
            @change="change"
            >
            <el-option :key=0 :label="$t('lang.lab_allVillage')" :value=0></el-option>
            <el-option v-for="item in gardens" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_infos')" prop="content" class="input-width">
          <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5}" :placeholder="$t('lang.lab_pleaseContent')" v-model="ruleForm.content" maxlength="1000"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_redpoint')" prop="red" class="input-width">
          <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5}"  :placeholder="$t('lang.lab_pleaseRed')" v-model="ruleForm.red" maxlength="1000"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_bluepoint')" prop="blue" class="input-width">
          <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5}"  :placeholder="$t('lang.lab_pleaseBlue')" v-model="ruleForm.blue" maxlength="1000"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_deadlineTime')" prop="endDate">
          <el-date-picker 
            class="outDate" 
            v-model="ruleForm.endDate" 
            type="date" 
            :placeholder="$t('lang.lab_selectDeadlineTime')" 
            value-format="timestamp"
            :picker-options="pickerOptions0">
          </el-date-picker>
        </el-form-item>
         <el-form-item :label="$t('lang.lab_uploadPhotograph')" v-if="this.id">
          <viewer :image="this.ruleForm.image" >
            <img :src="this.ruleForm.image" class="img" v-if="this.ruleForm.image"/>
          </viewer>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="image" ref="image" v-else>
         <upload-file ref="uploading" :accept='accept'  upTypes='1' :fileList='fileList' :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-file>
        </el-form-item>
       
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:neighborViewEdit
 *@Description:众邻观点-编辑/新增
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-04
 */
import UploadFile from '../../../components/upload_file.vue'
import {
    mapGetters
  } from 'vuex'
export default {
  data() {
    return {
      saveData: '',
      accept: '.jpg, .jpeg, .png',
      fileList: [], // 图片上传
      clears: false, // 清空按钮
      id: '', // id
      oldsearchUnit: [], // 复选输入框change前的数据
      index: '', // 复选的小区序号
      ruleForm: {
        content: '', // 内容
        red: '', // 红方观点
        blue: '', // 蓝方观点
        endDate: '', // 截止日期
        gardenId: '', // 小区ID
        gardenIds: '', // 小区IDs
        image: '' // 图片
      },
      rules: {
        content: [{ required: true, message: this.$i18n.t('lang.lab_pleaseContent'), trigger: 'blur' }],
        endDate: [{ type: 'date', required: true, message: this.$i18n.t('lang.lab_selectDeadlineTime'), trigger: 'blur' }],
      },
      gardenId: '', // 小区
      // gardens: [], // 小区集合
      garden: [], // 所选小区
      isDisabled: true, // 保存的可点击
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
    }
  },
  components: {
		'upload-file': UploadFile
  },
  destroyed() {
    window.localStorage.setItem('neighborViewForm', JSON.stringify(this.ruleForm))
    window.localStorage.setItem('neighborViewSaveData', JSON.stringify(this.saveData))
  },
  created() {
    this.id = this.$route.query.id
    if (window.localStorage.getItem('neighborViewForm')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('neighborViewForm'))
        if (this.ruleForm.gardenId) {
          this.ruleForm.gardenId = Number(this.ruleForm.gardenId)
        }
       if (window.localStorage.getItem('neighborViewSaveData')) {
          this.saveData = JSON.parse(window.localStorage.getItem('neighborViewSaveData'))
        }  
      
    if (this.id) {
       this.myGarden()
       } else {
         this.selectGarden()
          if (this.ruleForm.image) {
           this.fileList.push({
                name: '',
                url: this.ruleForm.image
              }) 
          }
        }
      } else {
    if (this.id) {
      this.myGarden()
      this.id = this.$route.query.id
      this.getData()
    } else {
      // this.selectGarden()
    } 
}
  },
  computed: {
      ...mapGetters({
        gardens: 'userGardenList'
      })
    },
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        // ruleForm数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    // 获取组件值
    getFile(e) {
      this.ruleForm.image = e
      this.$refs.image.clearValidate()
    },
    // 移除图片
    removeFile(e) {
      this.fileList = []
      this.ruleForm.image = ''
    },
    // 小区下拉
    myGarden() {
      let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.garden = myGardens
    },
    // 小区下拉
    // selectGarden() {
    //   this.$get(`/gardens`).then(
    //     res => {
    //       if (res && res.errCode === 0) {
    //         this.gardens = res.list
    //       }
    //     },
    //     error => {
    //       this.$message.error(error)
    //     }
    //   )
    // },
    // id查询详情
    getData() {
      let loading = this.$loading()
      this.$get(`/courtroomById/` + this.id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.ruleForm = res.courtroom
            if (this.ruleForm.image && this.ruleForm.image != '') {
              this.fileList.push({
                name: '',
                url: this.ruleForm.image
              }) 
            }
            // gardenId字符串转数字值
            this.ruleForm.gardenId = Number(this.ruleForm.gardenId)
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.saveData = JSON.stringify(this.ruleForm)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 保存
    save(formName) {
      if (this.isFlag === false) {
        // 验证所属小区是否为空
        if (this.ruleForm.gardenIds.length === 0) {
          this.$message.error(this.$i18n.t('lang.lab_selectOneVillage'))
          return
        }
        // 删除数组中的全选"0"
        if (this.ruleForm.gardenIds.includes(0)) {
          this.ruleForm.gardenIds.splice(0, 1)
        }
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          if (this.isFlag) {
            let params = {
              gardenId: this.ruleForm.gardenId,
              title: '',
              image: this.ruleForm.image,
              content: this.ruleForm.content,
              red: this.ruleForm.red,
              blue: this.ruleForm.blue,
              endTime: this.ruleForm.endDate,           
            }
            this.$patch(`/courtroom/${this.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_modify_success'))
                  this.$router.push({ name: 'neighborView' })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let params = { 
              'gardenIds[]': this.ruleForm.gardenIds.toString(),
              'image': this.ruleForm.image,
              'content': this.ruleForm.content,
              'red': this.ruleForm.red,
              'blue': this.ruleForm.blue,
              'endTime': this.ruleForm.endDate,
            }
            this.$post(`/courtroom`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.$router.push({ name: 'neighborView' })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        } else {
          return false
        }
      })
    },
    // 返回
    back() {
      this.$router.push({ name: 'neighborView' })
    },
    // 清空
    resetForm(formName) {
      this.clears = true
      this.$refs.ruleForm.clearValidate()
      this.ruleForm.content = '' // 内容
      this.ruleForm.red = '' // 红方观点
      this.ruleForm.blue = '' // 蓝方观点
      this.ruleForm.endDate = '' // 截止日期
      this.ruleForm.image = '' // 图片
      this.fileList = [] // 图片列表清空
      if (this.isFlag === false) {
        this.ruleForm.gardenIds = ''
      }
    },
    // 多选项
    change(val) {      
      const allValues = []
      // 将全选"0"加入allValues
      allValues.push(0)
      for (const item of this.gardens) {
        allValues.push(item.id)
      }
      // 用来储存上一次选择的值，可进行对比
      const oldVal = this.oldsearchUnit.length === 1 ? this.oldsearchUnit[0] : []
      // 若选择全部
      if (val.includes(0)) {
        this.ruleForm.gardenIds = allValues
      }
      // 取消全部选中， 上次有， 当前没有， 表示取消全选
      if (oldVal.includes(0) && !val.includes(0)) {
        this.ruleForm.gardenIds = []
      }
      // 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
      if (oldVal.includes(0) && val.includes(0)) {
        const index = val.indexOf(0)
        val.splice(index, 1)
        this.ruleForm.gardenIds = val
      }
      // 全选未选，但是其他选项都全部选上了，则全选选上
      if (!oldVal.includes(0) && !val.includes(0)) {
        if (val.length === allValues.length - 1) {
          this.ruleForm.gardenIds = [0].concat(val)
        }
      }
      // 储存当前选择的最后结果 作为下次的老数据
      this.oldsearchUnit[0] = this.ruleForm.gardenIds
    },

  }
}
</script>

<style lang="scss">
.neighborViewEdit {
  .single-select {
    width: 30%;
  }
  .multiple-select {
    width: 50%;
  }
  .input-width{
    width: 60%;
  }
  .img {
    width: 200px;
    height: 150px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }
}
</style>